/* @flow */
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import {
  setSelectedPair,
  setSelectedStableCoinTabs,
} from '../actions/settings';
import { setMarginStatus } from '../actions/actionsSet/margin';
import { setNativeCurrency } from '../actions/load';
import { getItem } from '../utils/localStorage';
import { eraseCookie } from '../utils/cookies-browser';

const USER_PREFERRED_CURRENCY_KEY = 'userPreferredCurrency';

export type Props = {
  setSelectedPair: Function,
  setSelectedStableCoinTabs: Function,
  setNativeCurrency: Function,
  setMarginStatus: Function,
  router: Object,
};

export default
@connect(
  null,
  {
    setSelectedPair,
    setSelectedStableCoinTabs,
    setNativeCurrency,
    setMarginStatus,
  }
)
class LocalStorageDataProvider extends PureComponent<Props> {
  componentDidMount() {
    eraseCookie('selectedAssetTab'); // not used
    const pairLabel = 'bn.selectedPair';
    const stableCoinTabsLabel = 'bn.selectedStableCoinTabs';
    const selectedPair = getItem(window.localStorage, pairLabel);
    const selectedStableCoinTabs = JSON.parse(getItem(window.localStorage, stableCoinTabsLabel));
    const userPreferredCurrency = getItem(window.localStorage, USER_PREFERRED_CURRENCY_KEY);
    if (selectedPair) this.props.setSelectedPair(selectedPair);
    if (selectedStableCoinTabs) this.props.setSelectedStableCoinTabs(selectedStableCoinTabs);
    if (userPreferredCurrency) {
      this.props.setNativeCurrency({
        configType: USER_PREFERRED_CURRENCY_KEY,
        configName: userPreferredCurrency,
      });
    }
  }

  render() {
    return null;
  }
}
